import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SharedPanelService } from '../../../../dms/layout/shared-panel/shared-panel.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { DataVehiculosService } from '../../../../dms/modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';
import { Child } from '../../../interfaces/child.interface';
import { AuthService } from '../../../services/auth.service';
import { SortDescriptor } from '@progress/kendo-data-query';
import { Vehicle } from '../../../interfaces/vehicle';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { GeneralGestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';
import { DataSaveService } from '../../../services/data-save.service';
import { RedirectService } from '../../../services/redirect.service';
import { ShortcutService } from '../../../../core/services/shortcut.service';

@Component({
    selector: 'app-tab-vehicles',
    templateUrl: './tab-vehicles.component.html',
    styleUrls: ['./tab-vehicles.component.scss']
})

@AutoUnsubscribe()
export class TabVehiclesComponent implements OnInit, OnDestroy {
    subjectCustomer: Subscription;
    error: string;
    code: string;
    isLoadingVehicles = false;
    customerId: string;

    VIN: string;
    @Input() formMode: boolean;
    @Input() modoEdicion?: boolean;
    @Input() cargarVista: string;
    @Input() readonlyMode: boolean = false;

    showModalVehicle: boolean;
    public pageSize: number;
    public pageNumber: number;
    public skip: number;
    deshabilitarBotones: boolean;
    selectedVehiculoIndex: number;
    selectedVehiculo: Vehicle = undefined;
    verHistorico: boolean;

    sort: SortDescriptor[] = [{
        field: 'PlateNumber',
        dir: 'asc'
    }
    ];
    gestionTerceros: boolean;
    gestionVehiculos: boolean;
    gestionOr: boolean;
    voClientes: boolean;
    stockVO: boolean;
    gestionVehiculosCortesia: boolean;
    items: any[];
    vehicles: Vehicle[];
    modalSubscription: Subscription;
    moduloTaller: any;
    child: Child;
    childs: Child[] = [];
    userProfile: any;
    public gridView: GridDataResult;
    height = '';
    chassis: string;
    botonGuardar: Subscription;
    canEditVehicleSub: Subscription;
    constructor(
        private _redirectService: RedirectService,
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        private toastr: ToastrService,
        private _authService: AuthService,
        private router: Router,
        private _dataSaveService: DataSaveService,
        private _dataVehiculosService: DataVehiculosService,
        public _sharedPanelService: SharedPanelService,
        public _gestionTercerosService: GestionTercerosService,
        public _shortcutService: ShortcutService
    ) {

        this.skip = 0;
        this.pageNumber = 1;
        this.pageSize = 10;
        this.deshabilitarBotones = true;
        // this.verHistorico = false;
    }
    ngOnDestroy(): void {
        if (this.canEditVehicleSub){
            this.canEditVehicleSub.unsubscribe();
        }
    }
    ngOnInit() {

        this.cargarVistas();
        this.userProfile = this._authService.getDataContents();
        this.childs = this.userProfile.AppModules;
        this.moduloTaller = this.childs[3];
        this.subjectCustomer = this._gestionTercerosService.observerActualCustomerCode().subscribe(val => {
            this.customerId = val;
        });

        this.getVehicles();

        this.botonGuardar = this._dataVehiculosService.observerBotonGuardar().subscribe(val => {
            if (val === true) {
                this.getVehicles(true);
            }
        });
        this.canEditVehicleSub = this._dataSaveService.canEditVehicle.subscribe(status => {
            if (status === false){
                this.getVehicles(true);
                this.deshabilitarBotones = true;
            }
        })
    }

    cargarVistas() {
        switch (this.cargarVista) {
            case 'gestionTerceros':
                this.gestionTerceros = true;
                this.gestionVehiculos = false;
                this.gestionOr = false;
                this.stockVO = false;
                this.voClientes = false;
                this.gestionVehiculosCortesia = false;

                this.height = '260';
                this.verHistorico = false;
                break;
            case 'gestionVehiculos':
                this.gestionTerceros = false;
                this.gestionVehiculos = true;
                this.gestionOr = false;
                this.stockVO = false;
                this.voClientes = false;
                this.gestionVehiculosCortesia = false;

                this.height = '230';
                this.verHistorico = true;
                break;

            case 'gestionVehiculosCortesia':
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.gestionVehiculosCortesia = true;
                this.gestionOr = false;
                this.stockVO = false;
                this.voClientes = false;

                this.height = '230';
                this.verHistorico = true;
                break;

            case 'gestionOr':
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = true;
                this.stockVO = false;
                this.voClientes = false;
                this.height = '240';
                break;
            case 'stockVO':
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.stockVO = true;
                this.voClientes = false;
                this.height = '240';
                this.verHistorico = true;
                break;
            case 'voClientes':
                this.gestionTerceros = false;
                this.gestionVehiculos = false;
                this.gestionVehiculosCortesia = false;
                this.gestionOr = false;
                this.stockVO = false;
                this.voClientes = true;
                this.height = '240';
                this.verHistorico = true;
                break;

        }
    }

    verHistoricoVehiculos() {
        this.verHistorico = true;
    }


    // Listado principal de vehiculos
    getVehicles(force?: boolean) {
        let savedData = null;
        if (!force) {
            savedData = this._dataSaveService.getData('DataVehicleByCustomerCode');
            if (savedData != null) {
                if (savedData.customerId !== this.customerId) {
                    savedData = null;
                } else {
                    savedData = savedData.data;
                }
            }
        }
        if (savedData == null) {
            this.isLoadingVehicles = true;
            const Parametros_IN = {
                'searchValue': this.customerId
            };
            const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetByCustomerCode`;
            this._generalGestionTercerosService.getDataVehicle(_URL_, Parametros_IN).subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.vehicles = auxdata;
                    this.gridView = {
                        data: this.vehicles,
                        total: this.vehicles.length
                    };
                    savedData = {
                        customerId: this.customerId,
                        data: auxdata
                    }
                    this._dataSaveService.setData('DataVehicleByCustomerCode', savedData);
                }

                this.isLoadingVehicles = false;

            });
        } else {
            this.vehicles = savedData;
            this.gridView = {
                data: this.vehicles,
                total: this.vehicles.length
            };
        }
    }

    selectVehiculo(event) {
        this.deshabilitarBotones = false;
        this.selectedVehiculoIndex = event.rowIndex;
        this.selectedVehiculo = event.dataItem;

        this.VIN = this.selectedVehiculo.Vin;
        this._dataVehiculosService.setVehicle(this.selectedVehiculo);
        const auxChassis = { 'chassis': this.selectedVehiculo.Chassis };
        this._dataSaveService.setChassis(this.cargarVista, auxChassis); ///Con servicio propio

    }

    getToOutApp() {
        const url = `${this._authService.getSeviboxURL()}/panier/vehicule.do?vin}=${this.VIN}`;
        window.open(url, '_blank');
    }

    recepcionVehiculo() {
        const params = { VIN: this.VIN };
        this._redirectService.redirectionTaller(this.moduloTaller, 3002, params);
        localStorage.setItem('SearchVin', this.VIN);
    }

    openModalVehicle() {
        this.showModalVehicle = true;
    }

    closeModalVehicle(result) {
        this.showModalVehicle = false;
        if (result) {
            this.getVehicles(true);
        }
    }


    cancelar() {
        this.deshabilitarBotones = true;
        this.verHistorico = false;
    }



}

